<template>
    <div id="order-info" class="container">
        <div v-for="recastId in recastOrders" class="mb-5">
            <umi-order :id="recastId"></umi-order>
        </div>
        <div class="text-right pb-5">
            <button class="btn btn-warning ml-3" type="button" @click.prevent="recastRequest">Запрос на переделку</button>
            <button class="btn btn-danger ml-3" type="button" @click.prevent="toRecast">Запуск в переделку</button>
            <button class="btn btn-info ml-3" type="button" @click.prevent="print">Конверт</button>
<!--            <button class="btn btn-secondary ml-3" type="button" @click.prevent="remove">Удалить</button>-->
        </div>
        <modals-container @close="fetchRecastOrders"/>
    </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import OrderPrintWrapper from '@/admin/components/OrderPrintWrapper.vue';
import RecastRequest from '@/admin/components/modals/RecastRequest.vue';
import ToRecast from '@/admin/components/modals/ToRecast.vue';
import Order from '@/admin/modules/Order/_components/Order.vue';
import UmiOrder from '@/admin/modules/Order/_components/UmiOrder';

const url = `${process.env.VUE_APP_API_HOST}admin/order`;

export default {
  components: {
    UmiOrder,
    Order,
  },
  data() {
    return {
      recastOrders: [],
      recastRecastMessage: '',
      order: {
        PaymentType: {
          Name: '',
        },
        PartnerPriceName: {
          Sku: '',
        },
        Delivery: {
          DeliveryDate: '',
        },
      },
      customer: {
        PartnerTour: {
          Name: '',
        },
      },
    };
  },
  computed: {
    clientSDays() {
      if (!this.order.Partner) {
        return '';
      }
      const SDays = {
        SDay1: 'ПН',
        SDay2: 'ВТ',
        SDay3: 'СР',
        SDay4: 'ЧТ',
        SDay5: 'ПТ',
      };
      const SDaysActive = [];
      _.forEach(SDays, (value, key) => {
        if (this.order.Partner[key]) {
          SDaysActive.push(value);
        }
      });
      return SDaysActive.concat();
    },
    lastOrderId() {
      if (this.recastOrders && _.last(this.recastOrders)) {
        return _.last(this.recastOrders);
      }
      return null;
    },
  },
  async mounted() {
    await this.fetchRecastOrders();
    await this.fetchOrder();
  },
  methods: {
    getTypeByDescendantClass(v) {
      return v.replace('App\\Models\\', '');
    },
    async fetchRecastOrders() {
      const { data } = await axios.get(`${url}/recast-orders/${this.$route.params.orderId}`);
      this.recastOrders = data;
    },
    async fetchOrder() {
      const { data } = await axios.get(`${url}/${this.$route.params.orderId}`);
      const { order, customer } = data;
      this.order = Object.assign({}, this.order, order);
      this.customer = customer;
    },
    print() {
      this.$modal.show(OrderPrintWrapper, {
        orderItemId: this.lastOrderId,
      }, {
        pivotY: 0.2,
        adaptive: true,
        width: '806px',
        height: '700px',
      });
    },
    recastRequest() {
      const lastOrderId = _.last(this.recastOrders);
      this.$modal.show(RecastRequest, {
        orderItemId: lastOrderId,
      }, {
        pivotY: 0.2,
        adaptive: true,
        height: 'auto',
      });
    },
    toRecast() {
      const lastOrderId = _.last(this.recastOrders);
      this.$modal.show(ToRecast, {
        orderItemId: lastOrderId,
      }, {
        pivotY: 0.2,
        adaptive: true,
        height: 'auto',
      });
    },
    remove() {
      if (!confirm('Удалить заказ?')) return;
      const lastOrderId = _.last(this.recastOrders);
      axios.delete(`${url}/${lastOrderId}`)
        .then((data) => {
          console.log(data);
          this.$router.push({ name: 'home' });
        });
    },
  },
};
</script>
<style lang="scss">
#order-edit {
    label {
        margin-bottom: .1rem !important;
    }

    .form-group {
        margin-bottom: .3rem !important;
    }
}
</style>
